import styles from "./styles.module.scss";

function Slide1({ intro }) {

    const handleScroll = (ref) => {
        window.scrollTo({
            top: ref.current.offsetTop,
            left: 0,
            behavior: "smooth",
        });
    }
    return (
        <>
            <section className={styles.container}>
                <div className={styles.picture}>
                    <img src="/images/carrousel/diigital.png" alt="digital" />
                </div>
                <div className={styles.info}>
                    <div className={styles.title}>OrgaExpert</div>
                    <div className={styles.title}>it & digital</div>
                    <div className={styles.title}>services</div>
                    <div className={styles.sub_title}>au coeur de la transformation numérique</div>

                    <div className={styles.link}>
                        <ul>
                            <li onClick={() => {
                                handleScroll(intro.current);
                            }}>
                                <a className={styles.animated_arrow} href="#">
                                    <span className={styles.the_arrow + " " + styles.left}>
                                        <span className={styles.shaft}></span>
                                    </span>
                                    <span className={styles.main}>
                                        <span className={styles.text}>
                                            EN SAVOIR PLUS
                                        </span>
                                        <span className={styles.the_arrow + " " + styles.right}>
                                            <span className={styles.shaft}></span>
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Slide1;